import { render, staticRenderFns } from "./tobeVip.vue?vue&type=template&id=529b68f1&scoped=true&"
import script from "./tobeVip.vue?vue&type=script&lang=js&"
export * from "./tobeVip.vue?vue&type=script&lang=js&"
import style0 from "./tobeVip.vue?vue&type=style&index=0&lang=less&"
import style1 from "./tobeVip.vue?vue&type=style&index=1&id=529b68f1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "529b68f1",
  null
  
)

export default component.exports